import {MANAGEMENT_DETAIL_TABLE_CONFIG_VARIANT} from './ManagementDashboard.attribute';
import ManagementDetail from './ManagementDetail/ManagementDetail';
import ManagementOverview from './ManagementOverview/ManagementOverview';
import styled from 'styled-components';
import ManagementDashboardModalProvider, {
    ManagementsDashboardModalPortal
} from './model/ctx/ManagementDashboard.context';

export default function ManagementDashboardPage() {
    return (
        <ManagementDashboardModalProvider>
            <PageContainer>
                <ManagementOverview />
                {MANAGEMENT_DETAIL_TABLE_CONFIG_VARIANT.map((variant) => (
                    <ManagementDetail id={variant} key={variant} variant={variant} />
                ))}
            </PageContainer>
            <ManagementsDashboardModalPortal />
        </ManagementDashboardModalProvider>
    );
}
const PageContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 31px;
`;
